export default __webpack_public_path__ + "static/media/img2.806ac481.jpg";